// Vue 2 / Vue CLI equivalent of vue3/src/features/customer-display/apiBaseUrl.js
// (which uses Vite's import.meta.env - not valid syntax under webpack 4/
// Vue CLI 4, hence this separate copy rather than a shared module). Same
// intent: direct backend origin for the Customer Display's one
// unauthenticated call (submit_rating).
//
// FALLBACK_API_BASE_URL is what a PRODUCTION build (no VUE_APP_API_BASE_URL
// set) uses, so it must be the production API -- never dev-api, even
// temporarily, since nothing distinguishes "someone forgot to set the env
// var" from "this really is production" once an unauthenticated rating
// submission actually reaches the wrong backend. A dev/local build that
// wants dev-api sets VUE_APP_API_BASE_URL itself, e.g. via a gitignored
// .env.development.local (see that file in this repo) -- never by editing
// this fallback.
const FALLBACK_API_BASE_URL = 'https://api.permtang.com';

// Pure, directly testable -- see src/baseUrl.js's resolveBaseUrl for why
// this takes the env value as an explicit argument rather than reading
// process.env internally (same rule, same reasoning, kept as two separate
// tiny functions rather than a shared import since the two fallback
// constants are each independently configurable).
export function resolveApiBaseUrl(envValue) {
  return envValue || FALLBACK_API_BASE_URL;
}

export const API_BASE_URL = resolveApiBaseUrl(process.env.VUE_APP_API_BASE_URL);
